/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { cn } from '@nextui-org/react';
import Autocomplete from '../Autocomplete';
import { IOptions, SelectCustomProps } from '../Select';
interface RHFAutocompleteProps extends SelectCustomProps {
  name: string;
  onChange?: (event: any) => void;
  selectionMode?: 'none' | 'single' | 'multiple';
  options: IOptions[];
  placeholder?: string;
  size?: 'lg' | 'sm' | 'md' | undefined;
  onValueChange?: any;
  onInputChange?: (value: string) => void;
  refreshListSearch?: VoidFunction;
  className?: string;
  isLoading?: boolean;
  // inputValue?:any
}

const RHFAutocomplete: React.FC<RHFAutocompleteProps & { isDisabled?: boolean }> = ({
  name,
  onChange,
  selectionMode = 'single',
  options,
  placeholder,
  refreshListSearch,
  onValueChange,
  onInputChange,
  size,
  isDisabled,
  isLoading,
  ...props
}) => {
  const { control, watch } = useFormContext<Record<string, any>>();
  const watchedValue = watch(name);
  const [inputVal, setInputVal] = useState('');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange: onFieldChange }, fieldState: { error } }) => {
        return (
          <>
            <Autocomplete
              id={name}
              className={cn(isDisabled && 'opacity-50 cursor-not-allowed pointer-events-none')}
              name={name}
              placeholder={placeholder}
              options={options}
              onValueChange={onValueChange}
              // value={value || ''}
              value={watchedValue || ''}
              selectedKey={watchedValue?.toString() || ''}
              // defaultSelectedKey={value?.toString() || ''}
              size={size}
              selectionMode={selectionMode}
              selectedKeys={selectionMode === 'multiple' ? new Set(watchedValue || []) : undefined}
              defaultSelectedKey={selectionMode === 'single' ? value?.toString() || '' : undefined}
              onSelectionChange={(e: any) => {
                if (selectionMode === 'multiple') {
                  onFieldChange(Array.from(e));
                } else {
                  onFieldChange(e);
                }
                onChange?.(e);
                if (onValueChange) {
                  onValueChange(e === '' ? '' : e);
                }
              }}
              onInputChange={(value: string) => {
                setInputVal(value);
                if (onInputChange) {
                  onInputChange(value);
                }
              }}
              isInvalid={!!error}
              errorMessage={error?.message}
              isLoading={isLoading}
              {...props}
            />
          </>
        );
      }}
    />
  );
};

export default RHFAutocomplete;
